// Iter 33d — Shared color palette for provider-owned (personal) blocks.
// Used across the Schedule Builder, Week View, Calendar Month view, and the
// Provider Rules card so a "testing" block reads the same everywhere.
//
// Keys mirror RecurringBlock.personal_kind values. Unknown kinds fall back
// to the neutral default (used for anything pre-Iter 33d).
export const PROVIDER_BLOCK_KINDS = [
  { value: "testing", label: "Testing" },
  { value: "meetings", label: "Meetings" },
  { value: "planning", label: "Planning" },
  { value: "lunch", label: "Lunch" },
  { value: "other", label: "Other" },
];

export const PROVIDER_BLOCK_COLORS = {
  testing: { bg: "#FDF8F3", border: "#D9A05B", text: "#8B5E1E", chip: "bg-[#FDF8F3] text-[#8B5E1E]" },
  meetings: { bg: "#EDF2F7", border: "#4A6B8C", text: "#2E4660", chip: "bg-[#EDF2F7] text-[#2E4660]" },
  planning: { bg: "#F3EEFA", border: "#8B6FC0", text: "#4F3A74", chip: "bg-[#F3EEFA] text-[#4F3A74]" },
  lunch: { bg: "#F4F8E9", border: "#8FA85F", text: "#4F6B30", chip: "bg-[#F4F8E9] text-[#4F6B30]" },
  other: { bg: "#F3F1EC", border: "#9B9890", text: "#4B5563", chip: "bg-[#F3F1EC] text-[#4B5563]" },
};

export const DEFAULT_PROVIDER_BLOCK_COLOR = PROVIDER_BLOCK_COLORS.other;

export function providerBlockColor(kind) {
  return PROVIDER_BLOCK_COLORS[kind] || DEFAULT_PROVIDER_BLOCK_COLOR;
}
